import Immutable from 'immutable';

const Content: {
  id: string,
  enabled: boolean,
  server: string,
  systemUser: string,
  password: string,
  isPasswordEdited: boolean,
  udn: string,
  groupMembership: string,
  ldaps: boolean
} = {
  id: '',
  enabled: false,
  server: '',
  systemUser: '',
  password: '',
  isPasswordEdited: false,
  udn: '',
  groupMembership: '',
  ldaps: false
};

class LdapConfig extends Immutable.Record(Content) {
  isNew (): boolean {
    return this.id === '';
  }
}

export default LdapConfig;
